import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "live-message-template-new",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "定型文を作成", -1)

import From from "./components/form.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(From)
  ]))
}
}

})